import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { Observable, of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';

import { NewsService } from '../services/news.service';

import * as fromActions from '../actions/news.actions';

@Injectable()
export class NewsEffects {
  constructor(
    private actions$: Actions,
    private newsService: NewsService
  ) {}

  getNews$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(ofType(fromActions.GetNews)).pipe(
      exhaustMap(() =>
        this.newsService.getNews().pipe(
          map((res: any) => fromActions.GetNewsSuccess(res)),
          catchError((err) => of(fromActions.GetNewsFailure(err)))
        )
      )
    )
  );

  getSocialMediaLinks$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(ofType(fromActions.GetSocialMediaLinks)).pipe(
      exhaustMap(() =>
        this.newsService.getSocialMediaLinks().pipe(
          map((res: any) => fromActions.GetSocialMediaLinksSuccess(res)),
          catchError((err) => of(fromActions.GetSocialMediaLinksFailure(err)))
        )
      )
    )
  );
}
